import red from '@material-ui/core/colors/red';

const themesConfig = {
    ouro_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#D4AF6E',
                main: '#D4AF6E',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#D4AF6E',
                main: '#D4AF6E',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    rosa_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#FECCE5',
                main: '#FECCE5',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FECCE5',
                main: '#FECCE5',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#81D9FE',
                main: '#459DC2',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#81D9FE',
                main: '#459DC2',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    roxo_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#B973FF',
                main: '#8500B2',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#B973FF',
                main: '#8500B2',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    salmao_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#FFAAAA',
                main: '#FFAAAA',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFAAAA',
                main: '#FFAAAA',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    verde_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#26FFC9',
                main: '#00B285',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#26FFC9',
                main: '#00B285',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    vermelho_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#FF0000',
                main: '#B20000',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FF0000',
                main: '#B20000',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    laranja_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#FFDFBF',
                main: '#FF8000',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFDFBF',
                main: '#FF8000',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    amarelo_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#FFFFBF',
                main: '#DBDB00',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFFFBF',
                main: '#DBDB00',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    cinza_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#BBBBBB',
                main: '#8F8E8F',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#BBBBBB',
                main: '#8F8E8F',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_novo_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#26C8FE',
                main: '#26C8FE',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#26C8FE',
                main: '#26C8FE',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_marinho_claro: {
        palette: {
            type: 'light',
            primary: {
                light: '#1B73B5',
                main: '#1B73B5',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#1B73B5',
                main: '#1B73B5',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    ouro_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#D4AF6E',
                main: '#D4AF6E',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#D4AF6E',
                main: '#D4AF6E',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    rosa_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#FECCE5',
                main: '#FECCE5',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FECCE5',
                main: '#FECCE5',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#81D9FE',
                main: '#459DC2',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#81D9FE',
                main: '#459DC2',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    roxo_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#B973FF',
                main: '#8500B2',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#B973FF',
                main: '#8500B2',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    salmao_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#FFAAAA',
                main: '#FFAAAA',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFAAAA',
                main: '#FFAAAA',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    verde_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#26FFC9',
                main: '#00B285',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#26FFC9',
                main: '#00B285',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    vermelho_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#FF0000',
                main: '#B20000',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FF0000',
                main: '#B20000',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    laranja_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#FFDFBF',
                main: '#FF8000',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFDFBF',
                main: '#FF8000',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    amarelo_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#FFFFBF',
                main: '#DBDB00',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#FFFFBF',
                main: '#DBDB00',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    cinza_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#BBBBBB',
                main: '#8F8E8F',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#BBBBBB',
                main: '#8F8E8F',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_novo_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#26C8FE',
                main: '#26C8FE',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#26C8FE',
                main: '#26C8FE',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    },
    azul_marinho_escuro: {
        palette: {
            type: 'dark',
            primary: {
                light: '#1B73B5',
                main: '#1B73B5',
                dark: '',
                contrastText: '#fff'
            },
            secondary: {
                light: '#1B73B5',
                main: '#1B73B5',
                dark: '',
                contrastText: '#fff'
            },
            error: red
        },
        status: {
            danger: 'orange'
        }
    }
};

export default themesConfig;
